import React from "react";
import Button from "./Button";
import Card from "./Card";
import HeadLines from "./HeadLines";
import style from "./style.module.css";

const CardWithButton = ({
  className,
  title,
  subtitle,
  buttonText,
  radius,
  onClick,
}) => {
  return (
    <Card
      className={`${radius ? "boxRadius8" : ""} d-flex flex-wrap ${className} ${
        style["cardWithButtonbackGround"]
      } padding16 margin-bottom16`}
    >
      <div className="flex50">
        <HeadLines
          className=" font-weight500 colorAccent2 padding-bottom8"
          text={title}
        />
        <HeadLines
          className="colorDark6 font-weight400 font-size12 line-height14 letterSpacing0025"
          text={subtitle}
        />
      </div>
      <Button
        className={`${style["buttonCSS"]} m-auto padding-bottom8 padding-top8 padding-left16 padding-right16 textColorWhite font-weight400 font-size12 line-height14 letterSpacing0025`}
        title={buttonText}
        onClick={onClick}
      />
    </Card>
  );
};
export default CardWithButton;
